const EN = {

    Global: {
        button_back: 'Back',
        button_cancel: 'Cancel',
        button_ok: 'OK',
        button_open: 'Open',
        button_reset: 'Reset',
        button_save_changes: 'Save Changes',
        heading_caution: 'Caution',
        heading_caution_caps_lock: 'CAUTION',
        title_email: 'Email',
        title_legal_notice: 'Legal Notice',
        title_password: 'Password',
        title_privacy_statement: 'Privacy Policy',
        text_none: 'None',
        toast_error: 'Oops, something went wrong, please try again.',
        toast_server_disconnect:'Server unavailable, please try later.'

    },
    PageTitles: {
        areas: 'Areas',
        devices: 'Devices',
        setup: 'Setup',
        user: 'User',
        settings: 'Settings',
        about: 'About '
    },
    Authentication: {
        button_signin: 'Login',
        button_signup: 'Register',
        button_password_forgot: 'Forgot password',
        toast_error: 'Email or password not correct!'
    },
      ChooseLanguage: {
        button_choose_language: 'Choose language'
      },
      DeviceCard: {
        label_id: 'Device ID',
        label_state: 'Status',
        content_update: 'Device update required',
        content_state_online: 'online',
        content_state_offline: 'Not connected.'
      },
      DeviceInformation: {
        toast_device_activation_success_01: 'The device ',
        toast_device_activation_success_02: ' has been activated.',
        toast_device_deletion_success_01: 'The device ',
        toast_device_deletion_success_02: ' has been removed.',
        sidebar_header_dialog_devices_title: 'Device information',
        sidebar_header_dialog_activation_hint: 'NOTE: ',
        sidebar_header_dialog_activation_text_01: 'By pressing the save button',
        sidebar_header_dialog_activation_text_02: 'the currently activated device will be deactivated',
        sidebar_header_dialog_activation_text_03: 'and is not controllable until reactivation',
        sidebar_header_dialog_device_deletion_caution: 'CAUTION: ',
        sidebar_header_dialog_device_deletion_text_01: 'By pressing the save button',
        sidebar_header_dialog_device_deletion_text_02: 'the device will be removed from the user account',
        sidebar_header_dialog_device_deletion_text_03: 'However, users who are connected to the device can still use it',
        sidebar_header_dialog_device_deletion_text_04: 'You can add it again when it is on your network',
        sidebar_header_dialog_user_deletion_title: 'Delete account',
        sidebar_header_dialog_user_deletion_caution: 'CAUTION: ',
        sidebar_header_dialog_user_deletion_text_01: 'Pressing the DELETE button will delete the',
        sidebar_header_dialog_user_deletion_text_02: 'User from this device. This operation',
        sidebar_header_dialog_user_deletion_text_03: 'cannot be undone',
        sidebar_header_dialog_user_deletion_text_04_s: 'This operation cannot be undone!',
        sidebar_users_section_subheading: 'Users',
        sidebar_users_section_caption: 'Email addresses associated with this device.',
        sidebar_sensors_section_subheading: 'Sensor values',
        sidebar_sensors_section_caption: 'Output sensor values of the connected device. ',
        sidebar_sensors_section_relative_humidity: 'rF',
        sidebar_sensors_section_no_sensor: 'no sensor',
        sidebar_messages_section_subheading: 'Messages',
        sidebar_messages_section_caption: 'Error messages about your connected device.',
        sidebar_messages_section_text_actual: 'Current',
        sidebar_messages_section_text_last: 'Last message',
        sidebar_uptime_section_subheading: 'Uptime',
        sidebar_uptime_section_caption: 'Time since device was connected or last reset.',
        sidebar_uptime_section_text_years: 'Year(s)',
        sidebar_uptime_section_text_days: 'Day(s)',
        sidebar_uptime_section_text_hours: 'Hour(s)',
        sidebar_uptime_section_text_minutes: 'Minute(s)',
        sidebar_gateway_specs_section_subheading: 'Information',
        sidebar_gateway_specs_section_caption: 'Hardware and software details of the connected gateway.',
        sidebar_gateway_specs_section_article_code: 'Article code',
        sidebar_gateway_specs_section_device_id: 'Device ID',
        sidebar_gateway_specs_section_firmware: 'Firmware',
        sidebar_device_specs_section_subheading: 'Information',
        sidebar_device_specs_section_caption: 'Hardware and software details of components.',
        sidebar_device_specs_section_control: 'Central control',
        sidebar_device_specs_section_bde_not_connected: 'not connected',
        sidebar_control_header: 'Control',
        sidebar_gateway_title: 'Gateway',
        sidebar_gateway_subheading: 'Status',
        sidebar_gateway_title: 'Which gateway is under active control.',
        button_gateway_activate: 'ACTIVATE',
        button_gateway_activated: 'ACTIVATED',
        sidebar_gateway_subheading_delete: 'Remove gateway',
        sidebar_gateway_caption_delete: 'Remove the link between device and user account.',
        button_gateway_delete_delete: 'DELETE',
        error_message_000: 'No message',
        error_message_001: 'Filter expired',
        error_message_002: 'No release',
        error_message_128: 'Communication error',
        error_message_129: 'Input value out of valid range (',
        error_message_130: 'No CO2 sensor connected for measured value',
        error_message_131: 'The device has the wrong bus version',
      },
      Devices: {
        toast_device_creation_success_01: 'The device ',
        toast_device_creation_success_02: ' was added.',
        toast_device_creation_error: 'Device could not be added',
        sidebar_header_create: 'add device',
        sidebar_item_header_create: 'Please enter the device ID and any name.',
        sidebar_input_label_deviceid_create: 'Device ID',
        sidebar_input_label_devicename_create: 'Device name',
        button_connect: 'CREATE CONNECTION',
        card_title_active: 'Active',
        card_replacement_no_active_devices: 'No active devices found',
        card_title_other: 'More devices',
        card_replacement_no_inactive_devices: 'No inactive devices found.'
      },
      Information: {
        headline: 'Imprint',
        company_name: 'SEVentilation GmbH',
        legal_info: 'Responsible for the content of this website in terms of press law, § 6 MDStV and § 6 TDG:',
        ceo_technic_heading: 'Managing Director Technology',
        ceo_technic: 'Dipl.-Wirt.-Ing. (FH) Nico Schellenberg',
        ceo_sales_heading: 'Managing Director Sales',
        ceo_sales: 'Dipl.-Wirt.-Ing. (FH) Alexander Buchspieß',
        ceos_address_heading: 'Seat of the company',
        ceos_address: 'Ernst Thälmann Str. 12-14<br/>07768 Kahla',
        contact_info_heading: 'Contact',
        contact_info: 'Tel: +49 (0)36424 767472<br/>Email: info@seventilation.de',
        commercial_register_heading: 'Commercial Register',
        commercial_register: 'HRB 510003<br/>Local court Jena',
        vat_heading: 'VAT',
        vat: 'DE293854001',
        privacy_heading: 'Data protection'
      },
      NoDevicesScreen: {
        heading: 'NOTE',
        subheading: 'No device is currently activated. An existing device can be activated in the "Devices" menu.',
        button_open_devices: 'OPEN DEVICES'
      },
      Onboarding: {
        title_device_registration: 'Device registration',
        helper_text_device_registration: 'Enter your device ID here. When doing so, make sure your device has an active Internet connection and you are on the same network.'
      },
      PasswordNew: {
        button_back_to_signin: 'Back to login',
        button_reset_password: 'Reset password',
        button_submit_new_password: 'Set password',
        error_text_repeat_password: 'The passwords do not match.',
        text_field_assign_new_password: 'Set new password',
        text_field_confirm_new_password: 'Confirm new password',
        toast_success: 'Password changed successfully. You can now log in.',
        toast_error: 'Input error, please check and correct new password!',
        toast_error_wrong_password: 'The current password is invalid.',
        toast_error_token_invalid: 'The link is invalid or expired, please try again.',
        success_text: 'Password was changed successfully.'
      },
      PasswordReset: {
        title: 'Account recovery',
        textfield_email_helpertext: 'Your registered email address',
        textfield_email_helpertext_error: 'Email address not available or incorrect',
        button_send_password: 'Send confirmation email',
        success_text: 'We have sent you a link to reset your password.',
        toast_success: 'Confirmation email sent successfully.',
        toast_error: 'Input error, please check and correct your mail address!',
        toast_error_no_user: 'No user was found with this email address.',
        button_to_signin: 'To login',
      },
      Registration: {
        title: 'Create your Account',
        toast_success: 'Thank you for your registration. Please check your email to complete the process.',
        toast_error: 'Input error, please check and correct inputs!',
        helpertext_error_password: 'The passwords do not match',
        textfield_helpertext_password: 'The password must have at least 12 characters',
        text_success:'Thank you for your registration. Please check your email to complete the process.',
        helpertext_error_email: 'Email address is not correct',
        label_choose_initial_password: 'Set password',
        label_confirm_initial_password: 'Confirm password',
        button_signup: 'Register',
        button_signin: 'To Login',
      },
      Settings: {
        sidebar_title_filter: 'Filter',
        sidebar_title_thresholds: 'Thresholds',
        sidebar_title_sleep: 'Snooze time',
        sidebar_title_devicetime: 'Device time',
        sidebar_title_summerventilation: 'Summer ventilation',

        text_date_time: ' clock',
        heading: 'Settings',
        card_label_filter: 'Filter',
        card_text_filter_change_01: 'Change',
        card_text_filter_change_02: 'in ',
        card_text_filter_change_03: ' days',
        card_text_filter_runtime_01: 'Runtime',
        card_text_filter_runtime_02: ' days',
        card_label_thresholds: 'Thresholds',
        card_text_thresholds_01: 'CO2',
        card_text_thresholds_02: 'Humidity',
        card_label_sleep: 'Snooze time',
        card_text_sleep_01: 'Duration',
        card_text_sleep_02: ' Min',
        card_label_devicetime: 'Device time',
        card_text_devicetime_01: 'Date',
        card_text_devicetime_02: 'Time',
        card_label_summerventilation: 'Summer ventilation',
        card_text_summerventilation_state: 'State',
        card_text_summerventilation_active: 'activated',
        card_text_summerventilation_not_active: 'not activated',
        card_helperlabel_summerventilation: 'Hint',
        card_helpertext_summerventilation: 'no heat recovery',

        sidebar_item_title_filter: 'Filter change',
        sidebar_item_subtitle_filter_01: 'In ',
        sidebar_item_subtitle_filter_02: ' days. After the filter change, please reset the filter running time.',
        sidebar_item_input_title_filter: 'Filter running time',
        sidebar_item_input_subtitle_filter: 'This is the period of time after which the filter must be exchanged.',
        sidebar_item_input_helpertext_filter_01: 'Value between ',
        sidebar_item_input_helpertext_filter_02: ' and ',
        sidebar_item_input_helpertext_filter_03: ' days in increments of ',
        sidebar_item_input_helpertext_filter_04: ' days.',
        sidebar_item_input_label_filter: ' Filter duration in days',

        sidebar_item_title_thresholds_co2: 'CO2',
        sidebar_item_helpertext_thresholds_co2_01: 'Value between ',
        sidebar_item_helpertext_thresholds_co2_02: ' and ',
        sidebar_item_helpertext_thresholds_co2_03: ' ppm in increments of ',
        sidebar_item_helpertext_thresholds_co2_04: ' ppm.',
        sidebar_item_label_thresholds_co2: 'Threshold value',
        sidebar_item_infotext_thresholds_co2_01: 'The current CO2 value is ',
        sidebar_item_infotext_thresholds_co2_02: ' ppm.',

        sidebar_item_title_thresholds_humidity: 'Humidity',
        sidebar_item_helpertext_thresholds_humidity_01: 'Value between ',
        sidebar_item_helpertext_thresholds_humidity_02: ' and ',
        sidebar_item_helpertext_thresholds_humidity_03: ' %.',
        sidebar_item_label_thresholds_humidity: 'Threshold',
        sidebar_item_infotext_thresholds_humidity_01: 'The current humidity is ',
        sidebar_item_infotext_thresholds_humidity_02: ' %.',

        sidebar_item_title_sleep: 'Snooze time',
        sidebar_item_helpertext_sleep_01: 'value between ',
        sidebar_item_helpertext_sleep_02: ' and ',
        sidebar_item_helpertext_sleep_03: ' minutes.',
        sidebar_item_label_sleep: 'Set time',

        sidebar_item_title_summerventilation_active: 'Summer ventilation is enabled',
        sidebar_item_title_summerventilation_inactive: 'Summer ventilation is disabled',
        sidebar_item_helpertext_summerventilation:'When summer ventilation is active, there is no heat recovery.',

        sidebar_item_devicetime_switch_active:'Automatic synchronization is enabled',
        sidebar_item_devicetime_switch_inactive: 'Automatic synchronization is disabled',
        sidebar_item_devicetime_switch_disabled: 'Automatic synchronization is not available',
        sidebar_item_devicetime_infotext: 'When Automatic Synchronization is active, time and date cannot be set manually.',
        sidebar_item_devicetime_label: 'Current device time',
        sidebar_item_devicetime_button_submit: 'Apply',
        sidebar_item_devicetime_firmwareupdate_infotext: 'Firmware update pending, function will be available soon.',

      },
      Setup: {
        text_factoryreset_01: 'By pressing the SAVE button, the original <br/>delivery state is restored. The operating hours of the <br/>system will also be reset.',
        text_factoryreset_02: 'This operation cannot be undone.',
        name_area: 'Area',
        menuitem_default: 'Please select',
        menuitem_boostmode_both: 'Supply and exhaust air',
        menuitem_boostmode_supply: 'Only supply air',
        menuitem_boostmode_exhaust: 'Only exhaust air',
        helpertext_boostmode: 'boost ventilation mode',
        name_system: 'System',
        menuitem_system_none: 'None',
        menuitem_system_configurable_device: 'Configurable device',
        helpertext_systems: 'Type of ventilation system',
        menuitem_area1: 'Area 1',
        menuitem_area2: 'Area 2',
        menuitem_area3: 'area 3',
        menuitem_area4: 'area 4',
        menuitem_area5: 'Area 5',
        menuitem_area6: 'Area 6',
        helpertext_areas_installed: 'Installed in area',
        sidebar_title_ai: 'Setting',
        menuitem_ai_0_10V: '0-10V',
        menuitem_ai_4_20mA: '4-20mA',
        helpertext_ai_kind: 'Input wiring',
        menuitem_ai_none: 'None',
        menuitem_ai_fanlevel: 'Fan stage',
        menuitem_ai_humidity: 'Humidity',
        menuitem_ai_co2: 'CO2',
        menuitem_ai_ti: 'Indoor temperature (Ti)',
        menuitem_ai_ta: 'Outdoor temperature (Ta)',
        helpertext_ai_function: 'Input function',
        formtitle_ai_set_characteristic: 'Set characteristic',
        sidebartitle_ai_choose_areas: 'Area selection',
        sidebar_title_di: 'Setting',
        menuitem_di_none: 'None',
        menuitem_di_set_fanlevel: 'Set fan stage ',
        menuitem_di_set_boost: 'Set boost ventilation',
        menuitem_di_set_sleep: 'Set to snooze',
        menuitem_di_set_time_automatic: 'Set to automatic timer',
        menuitem_di_set_co2: 'Set to CO2',
        menuitem_di_set_humidity: 'Set to humidity',
        menuitem_di_set_filter: 'Reset filter',
        menuitem_di_hold_fanlevel: 'Keep fan stage ',
        menuitem_di_hold_boost: 'Keep boost ventilation',
        menuitem_di_hold_time_automatic: 'Keep at automatic timer',
        menuitem_di_hold_co2: 'Keep at CO2',
        menuitem_di_hold_humidity: 'Keet at humidity',
        helpertext_di_function: 'Input function',
        sidebartitle_di_choose_areas: 'Area selection',
        sidebar_title_do: 'Setting',
        menuitem_do_none: 'None',
        menuitem_do_fan_active_01: 'Fan stage ',
        menuitem_do_fan_active_02: ' active',
        menuitem_do_boost: 'Boost ventilation active',
        menuitem_do_sleep: 'Snooze mode active',
        menuitem_do_all_zero: 'All areas fan stage 0',
        menuitem_do_time_automatic: 'Automatic timer active',
        menuitem_do_co2: 'CO2 active',
        menuitem_do_humidity: 'Humidity active',
        menuitem_do_filter: 'Filter exhausted',
        menuitem_do_message: 'General message',
        menuitem_do_error: 'General error',
        helpertext_do_function: 'Output function',
        sidebartitle_do_choose_areas: 'Area selection',
        card_label_systems: 'Ventilation systems',
        card_text_systems_01: 'Number',
        card_text_systems_02: 'systems active',
        card_label_boost: 'Areas',
        card_text_boost_01: 'Adjust',
        card_text_boost_02: 'boost ventilation',
        card_text_boost_03: 'of the areas',
        card_label_di: 'Input DI',
        card_text_di_01: 'Function',
        card_text_di_02: 'Areas',
        card_label_ai: 'Input AI',
        card_text_ai_01: 'Function',
        card_text_ai_02: 'Areas',
        card_label_do: 'Output DO',
        card_text_do_01: 'Function',
        card_text_do_02: 'Areas',
        card_label_factory_reset: 'Factory settings',
        card_text_factory_reset_01: 'Reset',
        card_text_factory_reset_02: 'system to',
        card_text_factory_reset_03: 'factory data',
        sidebartitle_curve: 'Set characteristic curve',
        sidebar_text_factory_reset: 'Reset'
      },
      SetupAuthorization: {
        paragraph_caution: 'This section contains settings for commissioning or service. Changes should only be made with caution.'
      },
      UpdateScreen: {
        headline: 'UPDATE NEEDED',
        subheading_01: 'The activated device must be updated',
        subheading_02: 'Please keep the device actively connected to the mains for at least 24h.',
        subheading_03: 'Under "Devices", another device can be activated for that long.',
        button_open_devices: 'SHOW DEVICES'
      },
      User: {
        heading_account_administration_delete: 'Delete account',
        sub_heading_account_administration_delete: 'Delete the account and all data' ,
        sidebartext_caution_delete_01: 'Pressing the DELETE button will delete the account and all associated data',
        sidebartext_caution_delete_02: 'This operation cannot be undone.',
        button_delete_account: 'Delete account',
        siebartext_change_password: 'You want to change your password? Please enter your current password first',
        title_api_access: 'Documentation',
        subtitle_api_access: 'The following link will redirect you to the API description',
        title_token: 'Token',
        subtitle_token: 'With a personal token you will get access to the SEC-Smart API',
        textfield_label_token: 'Copy access data',
        textfield_value_token: 'No token created',
        button_create: 'Create',
        button_revert: 'Undo',
        title_token_information: 'Information',
        text_token_information: 'Make sure you save the token. You will not be able to access it again',
        title_personalinformation_account: 'User account',
        subtitle_personalinformation_account: 'The email address associated with the account',
        title_personalinformation_password: 'Password',
        subtitle_personalinformation_password: 'Set a new password for your account',
        sidebartitle_passwordchange_no_action: 'Personal information',
        sidebartitle_passwordchange_action: 'Change password',
        sidebartitle_account_no_action: 'Account management',
        sidebartitle_account_action: 'Delete account',
        sidebartitle_api_no_action: 'SEC-Smart API',
        sidebartitle_api_action: 'Token created',
        toast_password_change_success: 'Password changed successfully',
        toast_account_deletion_success: 'Account successfully deleted.',
        card_label_personal_data: 'Personal data',
        card_text_personal_data_01: 'View',
        card_text_personal_data_02: 'Contact-',
        card_text_personal_data_03: 'information',
        card_text_personal_data_04: 'or change',
        card_text_personal_data_05: 'password',
        card_label_account_administration: 'Account administration',
        card_text_account_administration_01: 'Here you can',
        card_text_account_administration_02: 'download',
        card_text_account_administration_03: 'or delete',
        card_text_account_administration_04: 'your data',
        card_label_api: 'SEC-Smart API',
        card_text_api_01: 'View',
        card_text_api_02: 'description &',
        card_text_api_03: 'manage',
        card_text_api_04: 'access token',
        button_change: 'Change',
        label_actual_password: 'Current password',
        label_choose_new_password: 'Choose new password',
        label_confirm_new_password: 'Confirm new password',
        label_confirm_deletion: 'Confirm deletion',
        helpertext_account_deletion: "Enter 'DELETE' to confirm."
      },
      Scopes: {
        cardtext_label_manual: 'Manual',
        cardtext_content_manual: 'Stage',
        cardtext_label_boost: 'Boost',
        cardtext_content_boost: 'Maximum ventilation power',
        cardtext_label_sleep: 'Snooze',
        cardtext_content_sleep: '',
        cardtext_label_humi: 'Humidity',
        cardtext_content_humi: 'value',
        cardtext_label_time: 'Time program',
        cardtext_content_time: '',
        cardtext_label_co2: 'CO2',
        cardtext_content_co2: 'Value',
        title_mode_manual: 'Manual',
        title_mode_boost: 'Shock Ventilation',
        title_mode_sleep: 'Slumber',
        title_mode_humi: 'Humidity',
        title_mode_time: 'Time program',
        title_mode_co2: 'CO2',
        title_sidebar_customzie_area: 'Customize area',
        title_sidebar_customzie_time:'Configure switching time',
        title_dropwon_choose: 'Please choose',
        helpertext_choose_area_name: 'Choose name for area',
        title_mode: 'Mode',
        subtitle_mode: 'Set operating mode for the area',
        label_modeitem_manual: 'Manual',
        label_modeitem_boost: 'Boost',
        label_modeitem_sleep:'Snooze',
        label_modeitem_humi:'Humidity',
        label_modeitem_time:'Time program',
        label_modeitem_co2:'CO2',
        label_fanlevel: 'Fan stage',
        information_mode_boost_01: 'The system runs at maximum ventilation power.',
        information_mode_boost_02: 'Sufficient supply air must be ensured!',
        information_mode_sleep_01: 'Ventilation will be stopped for ',
        information_mode_sleep_02: ' minutes and',
        information_mode_sleep_03: ' after that fan stage 1 becomes active.',
        information_mode_humi_01: 'The ventilation power is automatically adjusted on the basis of the measured humidity of the room air.',
        information_mode_humi_02: 'The current humidity is',
        information_mode_time_01: 'Ventilation is performed according to the set time program.',
        information_mode_co2_01: 'The ventilation power is automatically adjusted on the basis of the measured CO2 value of the room air.',
        information_mode_co2_02: 'The current CO2 value is ',
        label_timepicker: 'Set time of next switching time.'

      },
      Misc: {
        label_switchtime: 'Switch. time ',
        sidebar_item_helpertext_ai_curve_01: 'Value between ',
        sidebar_item_helpertext_ai_curve_02: ' and ',
        navigation_item_choose_language: 'Language',
        navigation_item_logout: 'Logout',
    }
}

export default EN
